var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classnames from 'classnames';
import { OptionList } from '../..';
import { keys } from '../../../utilities';
const TimeOptions = (_a) => {
    var { className, options, onChange, focusValue, inputRef, dropdownRef, closeDropdown } = _a, rest = __rest(_a, ["className", "options", "onChange", "focusValue", "inputRef", "dropdownRef", "closeDropdown"]);
    const handleOptionKeyDown = (e, option) => {
        var _a, _b;
        const { key } = e;
        switch (key) {
            case keys.space:
            case keys.enter:
                e.preventDefault();
                onChange(option.value);
                return;
            case keys.esc:
                e.preventDefault();
                (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus(); // Close picker and go back to input
                closeDropdown();
                return;
            case keys.tab:
                if (!e.shiftKey) {
                    onChange(option.value); // Select value and go next focusable
                }
                if (e.shiftKey) {
                    e.preventDefault();
                    (_b = inputRef.current) === null || _b === void 0 ? void 0 : _b.focus(); // Focus on input
                    closeDropdown();
                }
        }
    };
    React.useEffect(() => {
        const timer = setTimeout(() => scrollOptionIntoView(dropdownRef), 10);
        return () => clearTimeout(timer);
    }, [options.length]); // eslint-disable-line
    return (options.length > 0 && (React.createElement("div", { ref: dropdownRef },
        React.createElement(OptionList, Object.assign({ arrowNavOptions: {
                disabled: false,
                loop: true,
                handleX: false,
                tabIndexGroup: false,
            }, className: classnames('m-1', className), focusValue: focusValue, options: options, onChange: onChange, optionOnKeyDown: handleOptionKeyDown }, rest)))));
};
export const TimePickerOptionList = React.memo(TimeOptions);
const scrollOptionIntoView = (dropdownRef) => {
    var _a;
    const selectedEl = (_a = dropdownRef === null || dropdownRef === void 0 ? void 0 : dropdownRef.current) === null || _a === void 0 ? void 0 : _a.querySelector(`.OptionList__option--selected, .OptionList__option-highlighted`);
    try {
        // Chrome, Safari, Edge
        selectedEl === null || selectedEl === void 0 ? void 0 : selectedEl.scrollIntoViewIfNeeded(); // Scrolls element into center of nearest scroll
    }
    catch (_b) {
        // Firefox
        selectedEl === null || selectedEl === void 0 ? void 0 : selectedEl.scrollIntoView({
            block: 'nearest', // Scroll over nearest block (dropdown) only, prevent body scrolling
        });
    }
};
//# sourceMappingURL=TimePickerOptionList.js.map